import { styled } from '@mui/system'
import { colors, fontSizes } from '../consts'

type FavProps = {
  favorited?: boolean
  teamColors?: string
}

export const TeamBackground = styled('div')<FavProps>(({ teamColors, theme }) => ({
  padding: theme.spacing(2),
  borderRadius: 6,
  backgroundColor: teamColors ? `#${teamColors.split('#')[1]}4D` : colors.white,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}))

export const BtnCon = styled('div')<FavProps>(({ favorited, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 12,
  border: `1px solid ${favorited ? colors.blue : colors.lightestGrey}`,
  padding: theme.spacing(1),
  margin: theme.spacing(1, 2),
  background: colors.white,
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(1, 1),
  },
  cursor: 'pointer',
  '& > div': {
    '& img': {
    width: 100,
    [theme.breakpoints.down('sm')]: {
      width: 60,
    },
  },
  },
  
  '& p': {
    fontWeight: 700,
    fontSize: fontSizes.medium,
    color: colors.text,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
}))

export const ActionItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 10,
  '& p': {
    fontSize: '0.7rem',
    fontWeight: 700,
    marginTop: 5,
    color: colors.text,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 500,
      fontSize: '0.6rem',
    },
  },
  '& svg': {
    width: 20,
    [theme.breakpoints.down('sm')]: {
      width: 15,
    },
  },
}))

export const TmHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 10,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  '& .actions': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    '& a': {
      padding: '0 15px',
      color: colors.text,
      borderRight: `1px solid ${colors.lightGrey}`,
      textDecoration: 'none',
      [theme.breakpoints.down('sm')]: {
        padding: '0 13px',
      },
      '&:last-of-type ': {
        borderRight: 0,
        paddingRight: 0,
      },
      '& > svg': {
        marginRight: 20,
        width: 30,
        height: 30,
      },
    },
  },
}))

export const HeadLink = styled('a')(({ theme }) => ({
  padding: '0 15px',
  color: colors.text,
  borderRight: `1px solid ${colors.lightGrey}`,
  textDecoration: 'none',
  [theme.breakpoints.down('sm')]: {
    padding: '0 13px',
  },
  '&:last-child': {
    borderRight: 0,
    paddingRight: 0,
  },
  '& svg': {
    width: 25,
    height: 25,
    [theme.breakpoints.down('sm')]: {
      width: 20,
      height: 20,
    },
  },
}))

export const SocHeadLink = styled('a')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& svg': {
    width: 18,
    height: 18,
    [theme.breakpoints.down('sm')]: {
      width: 12,
      height: 12,
    },
  },
}))

export const ChangeBtn = styled('a')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  '& p': {
    color: colors.text,
    fontSize: fontSizes.small,
    marginTop: 10,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}))

export const WelcomeCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': {
    width: 100,
    [theme.breakpoints.down('sm')]: {
      width: 70,
    },
  },
  '& h2': {
    fontWeight: 700,
    fontSize: fontSizes.semiLarge,
    color: colors.white,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}))

export const SubTextCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  '& :last-of-type': {
    borderRight: 'none',
  },
  '& p': {
    color: colors.white,
    fontSize: fontSizes.medium,
    // borderRight: `1px solid ${colors.white}`,
    textAlign: 'center',
    padding: theme.spacing(0, 1),
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
}))

export const TeamSelectCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
}))
